import { FlexBox, Icon, Typography } from '@vp/swan';
import React from 'react';
import './src-components-TypingIndicator-TypingIndicator.styles.scss.js';
import { isMobile } from './src-utils-mobile-utils.js';
import { getBrowserName } from './src-utils-app-utils.js';

const TypingIndicator = ({ senderType }) => {
  if (senderType === "chatbot") {
    return /* @__PURE__ */ React.createElement(FlexBox, null, /* @__PURE__ */ React.createElement(Icon, { iconType: "aiSupport", size: "20p" }), /* @__PURE__ */ React.createElement(
      Typography,
      {
        fontSize: "small",
        textColor: "subtle",
        paddingLeft: 6,
        className: "chatbot-typing-text",
        mb: isMobile() && getBrowserName() === "Safari" ? 6 : void 0
      },
      "Vista Assistant thinking..."
    ));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("svg", { height: "20", viewBox: "0 0 40 20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("circle", { className: "dot", cx: "5", cy: "10", r: "4", fill: "#555" }), /* @__PURE__ */ React.createElement("circle", { className: "dot", cx: "20", cy: "10", r: "4", fill: "#555" }), /* @__PURE__ */ React.createElement("circle", { className: "dot", cx: "35", cy: "10", r: "4", fill: "#555" })));
};

export { TypingIndicator as default };
//# sourceMappingURL=src-components-TypingIndicator-TypingIndicator.js.map
